export const CompanyCustomFieldForm = {
  en: {
    'Field label': 'Field label',
    'Custom field settings': 'Custom field settings',
    'Pick field type': 'Pick field type',
    Required: 'Required',
    Select: 'Drop-down list',
    Input: 'Text input',
    Textarea: 'Text input (multiline)',
    'Values for select': 'Values for select',
    'Field type': 'Field type',
    'Drop-down list items': 'Drop-down list items',
    Placeholder: 'Placeholder',
    'Linked forms': 'Linked forms',
    'Client Profile': 'Client Profile',
    Registration: 'Registration',
    Checkbox: 'Checkbox',
    'Edit Custom Field': 'Edit Custom Field',
    'New Custom Field': 'New Custom Field',
    'Create Custom Field': 'Create Custom Field',
    'Update Custom Field': 'Update Custom Field',
  },
  uk: {
    'Field label': 'Назва поля',
    'Custom field settings': 'Налаштування додаткового поля',
    'Pick field type': 'Оберіть тип поля',
    Required: 'Обовʼязкове до заповнення',
    Select: 'Випадний список',
    Input: 'Текстове поле',
    Textarea: 'Текстовий блок',
    'Values for select': 'Значення випадного списку',
    'Field type': 'Тип поля',
    'Drop-down list items': 'Елементи випадного списку',
    Placeholder: 'Базовий текст',
    'Linked forms': "Пов'язані форми",
    'Client Profile': 'Профіль клієнта',
    Registration: 'Реєстрація',
    Checkbox: 'Прапорець',
    'Edit Custom Field': 'Оновити Додаткове поле',
    'New Custom Field': 'Створення Додаткового поля',
    'Create Custom Field': 'Створити Додаткове поле',
    'Update Custom Field': 'Оновити Додаткове поле',
  },
};

export const CompanyCustomFields = {
  en: {
    'New Custom Field': 'New Custom Field',
    'Custom Fields': 'Custom Fields',
    Label: 'Label',
    'Field Type': 'Field Type',
    Select: 'Drop-down list',
    Input: 'Text input',
    Textarea: 'Text input (multiline)',
    Checkbox: 'Checkbox',
  },
  uk: {
    'New Custom Field': 'Створити Додаткове поле',
    'Custom Fields': 'Додаткові поля',
    Label: 'Назва поля',
    'Field Type': 'Тип поля',
    Textarea: 'Текстовий блок',
    Checkbox: 'Прапорець',
    Select: 'Випадний список',
    Input: 'Текстове поле',
  },
};
